export enum UserType {
    Alumni = "alumni",
    CSGO = "csgo",
    DSP = "dsp",
    Preboarder = "pb",
    SRU = "sru"
}